import cloneDeep from "clone-deep";
import fastDeepEqual from "fast-deep-equal/react.js";
import { useCallback, useContext, useEffect, useMemo } from "react";
import contextBabylon from "../../../../../context/index.js";
import { transformPassengersValueToText } from "../../../../../helpers/forms/passengers.js";
import { ClientApplication } from "../../../../../types/application.js";
import { updateSelectedOptions } from "../utils.js";
const MAX_PEOPLE = 9;
const applyVeciRestrictionsInNewValue = (newValue)=>{
    if (newValue.babies) {
        const newCombinedValue = (newValue.adults?.value ?? 0) + (newValue.children?.value ?? 0);
        newValue.babies.max = newCombinedValue;
        if (newValue.babies.value > newCombinedValue) {
            newValue.babies.value = newCombinedValue;
        }
        if (newValue.babies.selectedOptions && newValue.babies.selectedOptions.length > newCombinedValue) {
            newValue.babies.selectedOptions = newValue.babies.selectedOptions.slice(0, newCombinedValue - newValue.babies.selectedOptions.length);
        }
    }
};
const usePassengers = (props)=>{
    const { value ={} , onChange , label , disabled , icon ='user' , onBlur , hasError , error , literals  } = props;
    const { Application  } = useContext(contextBabylon);
    // initialize selectedOptions if not defined & update selectedOptions if value changes
    useEffect(()=>{
        let newValue = updateSelectedOptions(value);
        // TODO: review Application use
        if (Application === ClientApplication.veci && !!newValue.babies) {
            newValue.babies.max = (newValue.adults?.value ?? 0) + (newValue.children?.value ?? 0);
        }
        if (!fastDeepEqual(value, newValue)) {
            onChange?.(newValue);
        }
    }, [
        Application,
        onChange,
        value
    ]);
    const inputProps = useMemo(()=>({
            label: label ?? literals?.passengersLabel ?? literals?.passengerLabel ?? '',
            value: value ? transformPassengersValueToText(value, literals) : '',
            disabled,
            icon,
            onBlur,
            hasError,
            error
        }), [
        disabled,
        error,
        hasError,
        icon,
        label,
        literals,
        onBlur,
        value
    ]);
    const handleOnChange = useCallback((valueKey)=>(newValueNumber)=>{
            const newValue = cloneDeep(value);
            if (!newValue || !newValue?.[valueKey]?.value && newValue?.[valueKey]?.value !== 0 || newValue?.[valueKey]?.value === newValueNumber) return;
            newValue[valueKey].value = newValueNumber;
            // TODO: review Application use
            if (Application === ClientApplication.veci && [
                'adults',
                'children'
            ].includes(valueKey)) {
                applyVeciRestrictionsInNewValue(newValue);
            }
            onChange?.(newValue);
        }, [
        Application,
        onChange,
        value
    ]);
    const handleOnSelectChange = useCallback((valueKey)=>(selectedOptionIndex, newValueObject)=>{
            const newValue = cloneDeep(value);
            if (!newValue?.[valueKey]) return;
            newValue[valueKey].selectedOptions[selectedOptionIndex] = newValueObject.value;
            onChange?.(newValue);
        }, [
        onChange,
        value
    ]);
    const disableIncrement = useMemo(()=>{
        const values = [
            value?.adults?.value,
            value?.children?.value,
            value?.babies?.value,
            value?.majors?.value,
            value?.young?.value,
            value?.senior?.value,
            value?.umnr?.value
        ];
        return values.reduce((a = 0, b = 0)=>a + b, 0) === MAX_PEOPLE;
    }, [
        value?.adults?.value,
        value?.children?.value,
        value?.babies?.value,
        value?.majors?.value,
        value?.young?.value,
        value?.senior?.value,
        value?.umnr?.value
    ]);
    return {
        value,
        inputProps,
        disableIncrement,
        handleOnChange,
        handleOnSelectChange
    };
};
export default usePassengers;

//# sourceMappingURL=usePassengers.js.map